import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 主题蓝色
  colorPrimary: '#2563eb',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'AI Nexus',
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  siderWidth: 250,
  token: {
    sider: {
      colorMenuBackground: '#ffffff',
      colorTextMenu: '#262626',
      colorTextMenuSelected: '#1677ff',
      colorBgMenuItemSelected: '#e6f4ff',
      colorTextMenuItemHover: '#1677ff',
      colorBgMenuItemHover: '#f5f5f5',
    },
    pageContainer: {
      colorBgPageContainer: '#ffffff',
    },
  },
};

export default Settings;
